import BlockIcon from "@mui/icons-material/Block";
import CheckIcon from "@mui/icons-material/Check";
import { CircularProgress, InputAdornment } from "@mui/material";
import Alert from "@mui/material/Alert";
import TextField from "@mui/material/TextField";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { API } from "../../api/api";
import { useApiCall } from "../../hooks/useApiCall";
import i18nStore from "../../i18n/store";
import authUserStore from "../../modules/auth/store";


const TimeoutMs: number = 500;


interface LoginInputProps {
    login: string;
    setLogin: (login: string) => void;
    size?: "small" | "medium";
    checkUniqueness?: boolean;
    myLogin?: boolean;
}


const LoginInput = observer((props: LoginInputProps) => {
    const translations = i18nStore.getTranslations;

    useEffect(() => {
        if (!props.login) return;

        const delayInputTimeoutId = setTimeout(() => {
            checkUniquenessApi.apiCaller();
        }, TimeoutMs);
        return () => clearTimeout(delayInputTimeoutId);
    }, [props.login, TimeoutMs]);

    const checkUniquenessApi = useApiCall(
        () => API.users.checkLoginUniqueness(props.login),
        null,
    );

    const isLoginFree = (): boolean | null => {
        if (authUserStore.getMe?.name === props.login) return true;
        return checkUniquenessApi.data;
    };
    return (
        <>
            <TextField
                value={props.login}
                onChange={(e) => props.setLogin(e.target.value)}
                margin="normal"
                type="text"
                fullWidth
                id="login"
                label={translations.accountName}
                name="login"
                focused={props.myLogin}
                size={props.size || "small"}
                color={
                    checkUniquenessApi.loading
                        ? "info"
                        : isLoginFree()
                            ? "success"
                            : "error"
                }
                slotProps={{
                    input: {
                        endAdornment: (
                            <InputAdornment position="end">
                                {props.login.toString().length > 0 && !checkUniquenessApi.loading && (
                                    <>
                                        {isLoginFree() && <CheckIcon color="success" />}
                                        {isLoginFree() === false && <BlockIcon color="error" />}
                                    </>
                                )}
                                {checkUniquenessApi.loading && <CircularProgress size={20} />}
                            </InputAdornment>
                        ),
                    },
                }}
            />
            {isLoginFree() === false && (
                <Alert severity="error" sx={{py: 0, width: "100%"}} >
                    {translations._profile.loginIsTaken}
                </Alert>
            )}
        </>
    );
});

export default LoginInput;
